import { createFileRoute } from "@tanstack/react-router";
import { seo } from "@/lib/seo";
import StormDamage from "@/pages/services/StormDamage";

export const Route = createFileRoute("/_site/services/storm-damage")({
  head: () => ({
    ...seo({
      title: "Storm Damage Repair & Insurance Claims | Kodiak Structures & Exteriors",
      description:
        "24-hour emergency storm damage response throughout Minnesota. Hail, wind, and tree damage repair. We handle your insurance claim from start to finish.",
      path: "/services/storm-damage",
    }),
  }),
  component: StormDamage,
});
